/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EmberObject, { action } from '@ember/object';
import { task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';
import UserModel from 'cio/models/user';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';

let Validations = {
  code(value: string) {
    if (!value?.trim()) {
      return "Authentication code can't be blank.";
    }

    return true;
  },
};

interface StatusDisableFormPanelArgs {
  user: UserModel;
  isFormOpen: boolean;
  readOnly?: boolean;
  codeInputErrors?: string[];
  resetCodeInputErrors: () => unknown;
  disableLinkAction: () => unknown;
  onSubmit: (code: string) => Promise<unknown>;
  onCancel: () => unknown;
}

export default class StatusDisableFormPanel extends Component<StatusDisableFormPanelArgs> {
  @service auth!: AuthService;
  @service account!: AccountService;

  formValues = EmberObject.create({ code: '' });
  validations!: FormValidations;

  get readOnly() {
    return this.args?.readOnly ?? false;
  }

  submitTask = task(async (evt: Event) => {
    evt.preventDefault();

    try {
      await this.validations.validateModel();
    } catch (e) {
      // `validateModel` already found and set validation errors
      // return early to avoid executing real submit logic
      return;
    }

    return this.args.onSubmit(this.formValues.code);
  });

  constructor(owner: unknown, args: StatusDisableFormPanelArgs) {
    super(owner, args);

    this.validations = FormValidations.create({ validations: Validations, context: this, modelKey: 'formValues' });
  }

  @action
  handleCodeInput(val: string) {
    this.args.resetCodeInputErrors();
    this.formValues.set('code', val);
    this.validations.validateAttribute('code');
  }

  @action
  disableCancel() {
    this.formValues.set('code', '');
    this.validations.clearAttributeErrors('code');
    this.args.resetCodeInputErrors();
    this.validations.set('isTouched', false);
    this.args.onCancel();
  }
}
